module.exports = __webpack_public_path__ + "static/media/template (1).7940f96d.png";